'use client';

import React from 'react';
import {
  Eye,
  Flame,
  LayoutDashboard,
  LucideIcon,
  Rocket,
  Share2,
} from 'lucide-react';
import JobNavigationTabItem from './JobNavigationTabItem';
import { trackStatistic } from '@/lib/utils/statisticTracker';

export type JobTabType = 'all' | 'cv' | 'view' | 'share' | 'featured';

interface TabItem {
  id: JobTabType;
  label: string;
  icon: LucideIcon;
}

const items: TabItem[] = [
  { id: 'all', label: 'Бүх ажлын зар', icon: LayoutDashboard },
  { id: 'cv', label: 'Их CV авсан', icon: Flame },
  { id: 'view', label: 'Их үзсэн', icon: Eye },
  { id: 'share', label: 'Их хуваалцсан', icon: Share2 },
  { id: 'featured', label: 'Онцгой зар', icon: Rocket },
];

const tabStatKeys: Record<JobTabType, string> = {
  all: 'tab_all',
  featured: 'tab_featured',
  cv: 'tab_most_cv',
  view: 'tab_most_viewed',
  share: 'tab_most_shared',
};

const TAB_TYPES = new Set<string>(items.map((item) => item.id));

export default function JobNavigationTab({
  tabType,
  onTabChange,
}: {
  tabType: string;
  onTabChange: (value: JobTabType) => void;
}) {
  const activeId: JobTabType = TAB_TYPES.has(tabType)
    ? (tabType as JobTabType)
    : 'all';
  const activeItem = items.find((i) => i.id === activeId) ?? items[0];

  const onPress = (value: JobTabType) => {
    const key = tabStatKeys[value];
    if (key) trackStatistic(key);
    onTabChange(value);
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="md:hidden px-4 text-sm font-bold text-primary items-center">
        {activeItem.label}
      </div>

      <div className="flex items-center px-4 md:px-0 overflow-x-auto">
        {items.map((item) => (
          <JobNavigationTabItem
            key={item.id}
            active={item.id === activeId}
            onPress={() => onPress(item.id)}
            name={item.label}
            icon={item.icon}
          />
        ))}
      </div>
    </div>
  );
}
